<!--
  VFooter

  還原自 chunk-common.pretty.js L91。render function 已轉回 template。

  頁尾版權資訊與語言切換。切換語言時同時更新 Vuex（會寫入 cookie）
  與 vue-i18n 的 locale。

  注意：原始碼把 mapGetters 展開進 methods 而非 computed，
  因此 getLanguage 是以 this.getLanguage() 方式呼叫。此處保持原樣，
  避免改變行為。
-->

<template>
  <div class="card-footer d-flex jc-center jc-end">
    <div class="d-flex fd-column jc-space">
      <div class="info jc-center t-align-right">
        <p class="font-14 t-gray-12">
          Copyright © 2022 microx2sugar291 CO., LTD. All rights reserved
        </p>
      </div>
      <div class="info jc-center t-align-right">
        <p class="font-14 t-gray-12">
          Powered by
          <a class="t-gray-12" href="https://www.facebook.com/micro.x2.sugar.291/">microx2sugar291</a>
        </p>
      </div>
    </div>

    <div class="lang m-l-24">
      <div class="info jc-center d-flex fd-column">
        <p class="font-14 t-gray-12">語言</p>
        <p
          class="lang-select font-14 t-gray-12 m-t-4"
          :class="{ actived: lang == 'tw' }"
          @click="set_lang('tw')"
        >
          繁體中文
        </p>
        <p
          class="lang-select font-14 t-gray-12 m-t-4"
          :class="{ actived: lang == 'en' }"
          @click="set_lang('en')"
        >
          English
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import i18n from '@/i18n'

export default {
  data() {
    return { lang: this.getLanguage() }
  },

  methods: {
    ...mapActions(['setLanguage']),
    ...mapGetters(['getLanguage']),

    set_lang(lang) {
      if (lang === this.lang) return

      this.setLanguage(lang)
      this.lang = this.getLanguage()
      i18n.locale = this.getLanguage()
    }
  }
}
</script>
